<script>
    import addToBasket from "../events/addToBasket.js";
    import { onDestroy } from "svelte";

    /**
 *
 *
 *
 *
 *
 */

    /*                */
    let { variationId, widgetAdditionalClickTracking, additionalClickTracking, variant } = $props();

    let add2basketButtonClicked = $state(false);
    let timeoutId = null;

    const add2basketClickListener = (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (!add2basketButtonClicked) {
            add2basketButtonClicked = true;

            addToBasket(variationId, widgetAdditionalClickTracking, additionalClickTracking);

            timeoutId = setTimeout(() => {
                add2basketButtonClicked = false;
                timeoutId = null;
            }, 3000);
        }
    };

    onDestroy(() => {
        if (timeoutId) {
            clearTimeout(timeoutId);
        }
    });
</script>

<oc-button-v1
    size="50"
    type="button"
    {variant}
    icon-type-left={add2basketButtonClicked ? "check" : "basket"}
    success={add2basketButtonClicked}
    disabled={add2basketButtonClicked}
    class="reco_basketlayer_product_card__button"
    class:clicked={add2basketButtonClicked}
    onclick={add2basketClickListener}
    data-testid={`add_to_basket_${variant}_button`}
>
    <span>Hinzufügen</span>
</oc-button-v1>

<style>
    .reco_basketlayer_product_card__button {
    }
</style>
